// Generated by scripts/generate-anvil-variants.mjs. Do not edit by hand.
// Timings (in ms) for the play-once intro/outro APNGs and the main loop of
// each programmatic Codey working animation, so UI can chain
// `current outro -> next intro -> next loop` with plain setTimeout.
// `exits` lists the loop spans showing an outro's first frame, where the
// loop can hand off to that outro (`<name>-outro` for outro 0, else
// `<name>-outro-<n>`) without a seam.
export const ANVIL_TRANSITION_MANIFEST = {
  sleuthing: {
    introMs: 210,
    loopMs: 3120,
    exits: [
      { startMs: 0, endMs: 600, outro: 0, outroMs: 210 },
      { startMs: 1080, endMs: 1110, outro: 1, outroMs: 210 },
      { startMs: 1290, endMs: 1800, outro: 2, outroMs: 210 },
      { startMs: 1920, endMs: 2400, outro: 2, outroMs: 210 },
      { startMs: 2580, endMs: 2610, outro: 1, outroMs: 210 },
      { startMs: 3090, endMs: 3120, outro: 0, outroMs: 210 },
    ],
  },
  "on-fire": {
    introMs: 210,
    loopMs: 2880,
    exits: [
      { startMs: 0, endMs: 30, outro: 0, outroMs: 210 },
      { startMs: 510, endMs: 540, outro: 1, outroMs: 210 },
      { startMs: 1020, endMs: 1050, outro: 2, outroMs: 210 },
      { startMs: 1440, endMs: 1470, outro: 0, outroMs: 210 },
      { startMs: 1950, endMs: 1980, outro: 3, outroMs: 210 },
      { startMs: 2460, endMs: 2490, outro: 4, outroMs: 210 },
    ],
  },
  swimming: {
    introMs: 240,
    loopMs: 4800,
    exits: [
      { startMs: 0, endMs: 150, outro: 0, outroMs: 240 },
      { startMs: 600, endMs: 750, outro: 1, outroMs: 240 },
      { startMs: 1200, endMs: 1350, outro: 0, outroMs: 240 },
      { startMs: 1800, endMs: 1920, outro: 1, outroMs: 240 },
      { startMs: 1920, endMs: 1950, outro: 3, outroMs: 240 },
      { startMs: 2400, endMs: 2550, outro: 2, outroMs: 240 },
      { startMs: 3000, endMs: 3150, outro: 3, outroMs: 240 },
      { startMs: 3600, endMs: 3750, outro: 2, outroMs: 240 },
      { startMs: 4200, endMs: 4320, outro: 3, outroMs: 240 },
      { startMs: 4320, endMs: 4350, outro: 1, outroMs: 240 },
    ],
  },
  forging: {
    introMs: 300,
    loopMs: 1080,
    exits: [
      { startMs: 0, endMs: 480, outro: 0, outroMs: 300 },
      { startMs: 900, endMs: 1080, outro: 0, outroMs: 300 },
    ],
  },
  "forging-reverse": {
    introMs: 300,
    loopMs: 1080,
    exits: [
      { startMs: 0, endMs: 480, outro: 0, outroMs: 300 },
      { startMs: 900, endMs: 1080, outro: 0, outroMs: 300 },
    ],
  },
  "forging-reverse-v2": {
    introMs: 300,
    loopMs: 1080,
    exits: [
      { startMs: 0, endMs: 480, outro: 0, outroMs: 300 },
      { startMs: 900, endMs: 1080, outro: 0, outroMs: 300 },
    ],
  },
  "forging-bonk": {
    introMs: 300,
    loopMs: 1800,
    exits: [
      { startMs: 0, endMs: 240, outro: 0, outroMs: 300 },
      { startMs: 1320, endMs: 1800, outro: 0, outroMs: 300 },
    ],
  },
  eureka: {
    introMs: 300,
    loopMs: 3000,
    exits: [
      { startMs: 0, endMs: 600, outro: 0, outroMs: 300 },
      { startMs: 780, endMs: 900, outro: 1, outroMs: 300 },
      { startMs: 1020, endMs: 1140, outro: 1, outroMs: 300 },
      { startMs: 1140, endMs: 1200, outro: 2, outroMs: 300 },
      { startMs: 1320, endMs: 1440, outro: 2, outroMs: 300 },
      { startMs: 1560, endMs: 1680, outro: 2, outroMs: 300 },
      { startMs: 1800, endMs: 1920, outro: 2, outroMs: 300 },
      { startMs: 2040, endMs: 2160, outro: 2, outroMs: 300 },
      { startMs: 2280, endMs: 2400, outro: 2, outroMs: 300 },
      { startMs: 2520, endMs: 2580, outro: 2, outroMs: 300 },
      { startMs: 2580, endMs: 2820, outro: 1, outroMs: 300 },
      { startMs: 2820, endMs: 3000, outro: 0, outroMs: 300 },
    ],
  },
  juggling: {
    introMs: 360,
    loopMs: 3240,
    exits: [
      { startMs: 0, endMs: 120, outro: 0, outroMs: 360 },
      { startMs: 360, endMs: 480, outro: 0, outroMs: 360 },
      { startMs: 720, endMs: 840, outro: 0, outroMs: 360 },
      { startMs: 1080, endMs: 1200, outro: 0, outroMs: 360 },
      { startMs: 1440, endMs: 1560, outro: 0, outroMs: 360 },
      { startMs: 1800, endMs: 1920, outro: 0, outroMs: 360 },
      { startMs: 2160, endMs: 2280, outro: 0, outroMs: 360 },
      { startMs: 2520, endMs: 2640, outro: 0, outroMs: 360 },
      { startMs: 2880, endMs: 2940, outro: 0, outroMs: 360 },
    ],
  },
  caffeinating: {
    introMs: 270,
    loopMs: 4320,
    exits: [
      { startMs: 0, endMs: 90, outro: 0, outroMs: 270 },
      { startMs: 3240, endMs: 3330, outro: 0, outroMs: 270 },
    ],
  },
  orbiting: {
    introMs: 240,
    loopMs: 2880,
    exits: [
      { startMs: 0, endMs: 60, outro: 0, outroMs: 240 },
      { startMs: 540, endMs: 600, outro: 1, outroMs: 240 },
      { startMs: 1080, endMs: 1200, outro: 2, outroMs: 240 },
      { startMs: 1440, endMs: 1500, outro: 0, outroMs: 240 },
      { startMs: 1980, endMs: 2040, outro: 1, outroMs: 240 },
      { startMs: 2520, endMs: 2580, outro: 2, outroMs: 240 },
    ],
  },
  fishing: {
    introMs: 270,
    loopMs: 4800,
    exits: [
      { startMs: 0, endMs: 150, outro: 0, outroMs: 270 },
      { startMs: 600, endMs: 750, outro: 0, outroMs: 270 },
      { startMs: 1800, endMs: 1950, outro: 0, outroMs: 270 },
      { startMs: 2400, endMs: 2550, outro: 0, outroMs: 270 },
      { startMs: 4200, endMs: 4350, outro: 0, outroMs: 270 },
    ],
  },
  hero: {
    introMs: 300,
    loopMs: 3600,
    exits: [{ startMs: 0, endMs: 60, outro: 0, outroMs: 300 }],
  },
  zen: {
    introMs: 270,
    loopMs: 2880,
    exits: [
      { startMs: 0, endMs: 180, outro: 0, outroMs: 270 },
      { startMs: 570, endMs: 720, outro: 1, outroMs: 270 },
      { startMs: 1140, endMs: 1260, outro: 2, outroMs: 270 },
      { startMs: 1620, endMs: 1770, outro: 3, outroMs: 270 },
      { startMs: 2010, endMs: 2160, outro: 1, outroMs: 270 },
      { startMs: 2580, endMs: 2700, outro: 4, outroMs: 270 },
    ],
  },
  praying: {
    introMs: 270,
    loopMs: 2880,
    exits: [
      { startMs: 0, endMs: 240, outro: 0, outroMs: 270 },
      { startMs: 600, endMs: 720, outro: 0, outroMs: 270 },
    ],
  },
  sleeping: {
    introMs: 270,
    loopMs: 3600,
    exits: [
      { startMs: 0, endMs: 150, outro: 0, outroMs: 270 },
      { startMs: 150, endMs: 510, outro: 1, outroMs: 270 },
      { startMs: 510, endMs: 1320, outro: 2, outroMs: 270 },
      { startMs: 1320, endMs: 1680, outro: 1, outroMs: 270 },
      { startMs: 1680, endMs: 1950, outro: 0, outroMs: 270 },
      { startMs: 1950, endMs: 2310, outro: 3, outroMs: 270 },
      { startMs: 2310, endMs: 3120, outro: 4, outroMs: 270 },
      { startMs: 3120, endMs: 3480, outro: 3, outroMs: 270 },
      { startMs: 3480, endMs: 3600, outro: 0, outroMs: 270 },
    ],
  },
  grooving: {
    introMs: 270,
    loopMs: 2880,
    exits: [
      { startMs: 0, endMs: 120, outro: 0, outroMs: 270 },
      { startMs: 1440, endMs: 1560, outro: 0, outroMs: 270 },
    ],
  },
  raincloud: {
    introMs: 330,
    loopMs: 3600,
    exits: [
      { startMs: 0, endMs: 60, outro: 0, outroMs: 330 },
      { startMs: 300, endMs: 360, outro: 0, outroMs: 330 },
      { startMs: 600, endMs: 660, outro: 0, outroMs: 330 },
      { startMs: 900, endMs: 960, outro: 0, outroMs: 330 },
      { startMs: 1200, endMs: 1260, outro: 0, outroMs: 330 },
      { startMs: 1500, endMs: 1560, outro: 0, outroMs: 330 },
      { startMs: 1800, endMs: 1860, outro: 0, outroMs: 330 },
      { startMs: 2100, endMs: 2160, outro: 0, outroMs: 330 },
      { startMs: 2400, endMs: 2460, outro: 0, outroMs: 330 },
      { startMs: 2700, endMs: 2760, outro: 0, outroMs: 330 },
      { startMs: 3000, endMs: 3060, outro: 0, outroMs: 330 },
    ],
  },
  "leg-day": {
    introMs: 210,
    loopMs: 2790,
    exits: [
      { startMs: 0, endMs: 300, outro: 0, outroMs: 210 },
      { startMs: 2370, endMs: 2490, outro: 0, outroMs: 210 },
      { startMs: 2610, endMs: 2790, outro: 0, outroMs: 210 },
    ],
  },
  running: {
    introMs: 390,
    loopMs: 1440,
    exits: [
      { startMs: 0, endMs: 60, outro: 0, outroMs: 390 },
      { startMs: 480, endMs: 540, outro: 0, outroMs: 390 },
      { startMs: 960, endMs: 1020, outro: 0, outroMs: 390 },
    ],
  },
  tripping: {
    introMs: 240,
    loopMs: 2880,
    exits: [
      { startMs: 0, endMs: 30, outro: 0, outroMs: 240 },
      { startMs: 1440, endMs: 1470, outro: 0, outroMs: 240 },
    ],
  },
  doomscrolling: {
    introMs: 330,
    loopMs: 6480,
    exits: [
      { startMs: 0, endMs: 120, outro: 0, outroMs: 330 },
      { startMs: 510, endMs: 540, outro: 3, outroMs: 330 },
      { startMs: 600, endMs: 630, outro: 1, outroMs: 330 },
      { startMs: 1110, endMs: 1140, outro: 2, outroMs: 330 },
      { startMs: 1230, endMs: 1800, outro: 3, outroMs: 330 },
      { startMs: 2100, endMs: 2760, outro: 3, outroMs: 330 },
      { startMs: 3150, endMs: 3660, outro: 4, outroMs: 330 },
      { startMs: 3960, endMs: 4560, outro: 4, outroMs: 330 },
      { startMs: 5040, endMs: 5070, outro: 5, outroMs: 330 },
      { startMs: 5430, endMs: 5460, outro: 0, outroMs: 330 },
      { startMs: 5880, endMs: 5910, outro: 1, outroMs: 330 },
      { startMs: 6030, endMs: 6480, outro: 0, outroMs: 330 },
    ],
  },
  smoking: {
    introMs: 210,
    loopMs: 4320,
    exits: [{ startMs: 0, endMs: 90, outro: 0, outroMs: 210 }],
  },
  "yo-yo": {
    introMs: 330,
    loopMs: 2880,
    exits: [
      { startMs: 0, endMs: 60, outro: 0, outroMs: 330 },
      { startMs: 1200, endMs: 1500, outro: 0, outroMs: 330 },
      { startMs: 2640, endMs: 2880, outro: 0, outroMs: 330 },
    ],
  },
  dribbling: {
    introMs: 330,
    loopMs: 2880,
    exits: [
      { startMs: 0, endMs: 30, outro: 0, outroMs: 330 },
      { startMs: 690, endMs: 750, outro: 0, outroMs: 330 },
      { startMs: 1410, endMs: 1470, outro: 0, outroMs: 330 },
      { startMs: 2130, endMs: 2190, outro: 0, outroMs: 330 },
      { startMs: 2850, endMs: 2880, outro: 0, outroMs: 330 },
    ],
  },
  tv: {
    introMs: 360,
    loopMs: 4320,
    exits: [
      { startMs: 0, endMs: 120, outro: 0, outroMs: 360 },
      { startMs: 480, endMs: 600, outro: 0, outroMs: 360 },
      { startMs: 960, endMs: 1200, outro: 0, outroMs: 360 },
      { startMs: 1560, endMs: 1680, outro: 0, outroMs: 360 },
      { startMs: 2040, endMs: 2280, outro: 0, outroMs: 360 },
      { startMs: 2640, endMs: 2760, outro: 0, outroMs: 360 },
      { startMs: 3120, endMs: 3360, outro: 0, outroMs: 360 },
      { startMs: 3720, endMs: 3840, outro: 0, outroMs: 360 },
      { startMs: 4200, endMs: 4320, outro: 0, outroMs: 360 },
    ],
  },
  weightlifting: {
    introMs: 300,
    loopMs: 2880,
    exits: [
      { startMs: 0, endMs: 120, outro: 0, outroMs: 300 },
      { startMs: 600, endMs: 840, outro: 0, outroMs: 300 },
      { startMs: 1320, endMs: 1560, outro: 0, outroMs: 300 },
      { startMs: 2040, endMs: 2280, outro: 0, outroMs: 300 },
      { startMs: 2760, endMs: 2880, outro: 0, outroMs: 300 },
    ],
  },
  ufo: {
    introMs: 360,
    loopMs: 4320,
    exits: [
      { startMs: 0, endMs: 60, outro: 0, outroMs: 360 },
      { startMs: 510, endMs: 600, outro: 0, outroMs: 360 },
      { startMs: 1050, endMs: 1140, outro: 0, outroMs: 360 },
    ],
  },
  matrix: {
    introMs: 240,
    loopMs: 4320,
    exits: [{ startMs: 0, endMs: 60, outro: 0, outroMs: 240 }],
  },
  saber: {
    introMs: 240,
    loopMs: 2880,
    exits: [
      { startMs: 0, endMs: 30, outro: 0, outroMs: 240 },
      { startMs: 2640, endMs: 2700, outro: 0, outroMs: 240 },
    ],
  },
  "caffeinating-hold": {
    introMs: 270,
    loopMs: 1080,
    exits: [
      { startMs: 0, endMs: 90, outro: 0, outroMs: 270 },
      { startMs: 540, endMs: 630, outro: 1, outroMs: 270 },
    ],
  },
  "beautiful-mind": {
    introMs: 210,
    loopMs: 7500,
    exits: [
      { startMs: 0, endMs: 25, outro: 0, outroMs: 210 },
      { startMs: 525, endMs: 550, outro: 1, outroMs: 210 },
      { startMs: 1050, endMs: 1075, outro: 2, outroMs: 210 },
      { startMs: 1575, endMs: 1600, outro: 3, outroMs: 210 },
      { startMs: 2100, endMs: 2125, outro: 4, outroMs: 210 },
      { startMs: 2625, endMs: 2650, outro: 5, outroMs: 210 },
      { startMs: 3150, endMs: 3175, outro: 6, outroMs: 210 },
      { startMs: 3675, endMs: 3700, outro: 7, outroMs: 210 },
      { startMs: 4200, endMs: 4225, outro: 8, outroMs: 210 },
      { startMs: 4725, endMs: 4750, outro: 9, outroMs: 210 },
      { startMs: 5250, endMs: 5275, outro: 10, outroMs: 210 },
      { startMs: 5775, endMs: 5800, outro: 11, outroMs: 210 },
      { startMs: 6300, endMs: 6325, outro: 12, outroMs: 210 },
      { startMs: 6825, endMs: 6850, outro: 13, outroMs: 210 },
      { startMs: 7350, endMs: 7375, outro: 14, outroMs: 210 },
      { startMs: 7450, endMs: 7500, outro: 0, outroMs: 210 },
    ],
  },
  concentrate: {
    introMs: 210,
    loopMs: 5452,
    exits: [
      { startMs: 0, endMs: 58, outro: 0, outroMs: 210 },
      { startMs: 145, endMs: 580, outro: 1, outroMs: 210 },
      { startMs: 667, endMs: 696, outro: 2, outroMs: 210 },
      { startMs: 725, endMs: 754, outro: 2, outroMs: 210 },
      { startMs: 783, endMs: 812, outro: 2, outroMs: 210 },
      { startMs: 841, endMs: 870, outro: 2, outroMs: 210 },
      { startMs: 899, endMs: 928, outro: 2, outroMs: 210 },
      { startMs: 957, endMs: 986, outro: 2, outroMs: 210 },
      { startMs: 1015, endMs: 1044, outro: 2, outroMs: 210 },
      { startMs: 1073, endMs: 1102, outro: 2, outroMs: 210 },
      { startMs: 1131, endMs: 1160, outro: 2, outroMs: 210 },
      { startMs: 1189, endMs: 1218, outro: 2, outroMs: 210 },
      { startMs: 1247, endMs: 1276, outro: 2, outroMs: 210 },
      { startMs: 1305, endMs: 1334, outro: 2, outroMs: 210 },
      { startMs: 1363, endMs: 1392, outro: 2, outroMs: 210 },
      { startMs: 1421, endMs: 1450, outro: 2, outroMs: 210 },
      { startMs: 1479, endMs: 1508, outro: 2, outroMs: 210 },
      { startMs: 1537, endMs: 1566, outro: 2, outroMs: 210 },
      { startMs: 1595, endMs: 1624, outro: 2, outroMs: 210 },
      { startMs: 1653, endMs: 1682, outro: 2, outroMs: 210 },
      { startMs: 1711, endMs: 1740, outro: 2, outroMs: 210 },
      { startMs: 1769, endMs: 1798, outro: 2, outroMs: 210 },
      { startMs: 1827, endMs: 1856, outro: 2, outroMs: 210 },
      { startMs: 1885, endMs: 1914, outro: 2, outroMs: 210 },
      { startMs: 1943, endMs: 1972, outro: 2, outroMs: 210 },
      { startMs: 2001, endMs: 2030, outro: 2, outroMs: 210 },
      { startMs: 2088, endMs: 2465, outro: 1, outroMs: 210 },
      { startMs: 2552, endMs: 2581, outro: 2, outroMs: 210 },
      { startMs: 2610, endMs: 2639, outro: 2, outroMs: 210 },
      { startMs: 2668, endMs: 2697, outro: 2, outroMs: 210 },
      { startMs: 2726, endMs: 2755, outro: 2, outroMs: 210 },
      { startMs: 2784, endMs: 2813, outro: 2, outroMs: 210 },
      { startMs: 2842, endMs: 2871, outro: 2, outroMs: 210 },
      { startMs: 2900, endMs: 2929, outro: 2, outroMs: 210 },
      { startMs: 2958, endMs: 2987, outro: 2, outroMs: 210 },
      { startMs: 3016, endMs: 3045, outro: 2, outroMs: 210 },
      { startMs: 3074, endMs: 3103, outro: 2, outroMs: 210 },
      { startMs: 3132, endMs: 3161, outro: 2, outroMs: 210 },
      { startMs: 3190, endMs: 3219, outro: 2, outroMs: 210 },
      { startMs: 3248, endMs: 3277, outro: 2, outroMs: 210 },
      { startMs: 3306, endMs: 3335, outro: 2, outroMs: 210 },
      { startMs: 3364, endMs: 3393, outro: 2, outroMs: 210 },
      { startMs: 3422, endMs: 3451, outro: 2, outroMs: 210 },
      { startMs: 3480, endMs: 3509, outro: 2, outroMs: 210 },
      { startMs: 3538, endMs: 3567, outro: 2, outroMs: 210 },
      { startMs: 3596, endMs: 3625, outro: 2, outroMs: 210 },
      { startMs: 3654, endMs: 3683, outro: 2, outroMs: 210 },
      { startMs: 3712, endMs: 3741, outro: 2, outroMs: 210 },
      { startMs: 3770, endMs: 3799, outro: 2, outroMs: 210 },
      { startMs: 3828, endMs: 3857, outro: 2, outroMs: 210 },
      { startMs: 3886, endMs: 3915, outro: 2, outroMs: 210 },
      { startMs: 3944, endMs: 3973, outro: 2, outroMs: 210 },
      { startMs: 4002, endMs: 4031, outro: 2, outroMs: 210 },
      { startMs: 4060, endMs: 4089, outro: 2, outroMs: 210 },
      { startMs: 4118, endMs: 4147, outro: 2, outroMs: 210 },
      { startMs: 4176, endMs: 4205, outro: 2, outroMs: 210 },
      { startMs: 4234, endMs: 4263, outro: 2, outroMs: 210 },
      { startMs: 4292, endMs: 4321, outro: 2, outroMs: 210 },
      { startMs: 4350, endMs: 4379, outro: 2, outroMs: 210 },
      { startMs: 4408, endMs: 4437, outro: 2, outroMs: 210 },
      { startMs: 4466, endMs: 4495, outro: 2, outroMs: 210 },
      { startMs: 4524, endMs: 4553, outro: 2, outroMs: 210 },
      { startMs: 4582, endMs: 4611, outro: 2, outroMs: 210 },
      { startMs: 4640, endMs: 4669, outro: 2, outroMs: 210 },
      { startMs: 4698, endMs: 4727, outro: 2, outroMs: 210 },
      { startMs: 4756, endMs: 4785, outro: 2, outroMs: 210 },
      { startMs: 4814, endMs: 4843, outro: 2, outroMs: 210 },
      { startMs: 4930, endMs: 5452, outro: 1, outroMs: 210 },
    ],
  },
  considering: {
    introMs: 270,
    loopMs: 2900,
    exits: [
      { startMs: 0, endMs: 29, outro: 0, outroMs: 270 },
      { startMs: 464, endMs: 725, outro: 1, outroMs: 270 },
      { startMs: 1189, endMs: 1421, outro: 2, outroMs: 270 },
      { startMs: 1856, endMs: 2204, outro: 3, outroMs: 270 },
      { startMs: 2668, endMs: 2900, outro: 0, outroMs: 270 },
    ],
  },
  idle: {
    introMs: 210,
    loopMs: 8700,
    exits: [
      { startMs: 0, endMs: 638, outro: 0, outroMs: 210 },
      { startMs: 725, endMs: 1624, outro: 1, outroMs: 270 },
      { startMs: 1711, endMs: 3509, outro: 0, outroMs: 210 },
      { startMs: 3596, endMs: 5858, outro: 0, outroMs: 210 },
      { startMs: 5945, endMs: 7337, outro: 0, outroMs: 210 },
      { startMs: 7424, endMs: 8700, outro: 0, outroMs: 210 },
    ],
  },
  pong: {
    introMs: 210,
    loopMs: 7801,
    exits: [
      { startMs: 0, endMs: 29, outro: 0, outroMs: 210 },
      { startMs: 232, endMs: 580, outro: 1, outroMs: 210 },
      { startMs: 1073, endMs: 1102, outro: 2, outroMs: 210 },
      { startMs: 1595, endMs: 1624, outro: 3, outroMs: 210 },
      { startMs: 2117, endMs: 2146, outro: 4, outroMs: 210 },
      { startMs: 2639, endMs: 2668, outro: 5, outroMs: 210 },
      { startMs: 3161, endMs: 3190, outro: 6, outroMs: 210 },
      { startMs: 3683, endMs: 3712, outro: 7, outroMs: 210 },
      { startMs: 4205, endMs: 4234, outro: 8, outroMs: 210 },
      { startMs: 4727, endMs: 4756, outro: 9, outroMs: 210 },
      { startMs: 5249, endMs: 5278, outro: 10, outroMs: 210 },
      { startMs: 5771, endMs: 5800, outro: 11, outroMs: 210 },
      { startMs: 6293, endMs: 6322, outro: 12, outroMs: 210 },
      { startMs: 6670, endMs: 6786, outro: 13, outroMs: 210 },
      { startMs: 6815, endMs: 6902, outro: 13, outroMs: 210 },
      { startMs: 6989, endMs: 7598, outro: 13, outroMs: 210 },
      { startMs: 7685, endMs: 7801, outro: 13, outroMs: 210 },
    ],
  },
  pondering: {
    introMs: 210,
    loopMs: 3074,
    exits: [
      { startMs: 0, endMs: 493, outro: 0, outroMs: 210 },
      { startMs: 986, endMs: 1015, outro: 1, outroMs: 210 },
      { startMs: 1508, endMs: 1537, outro: 2, outroMs: 210 },
      { startMs: 2030, endMs: 2059, outro: 3, outroMs: 210 },
      { startMs: 2320, endMs: 2842, outro: 4, outroMs: 210 },
    ],
  },
  ruminating: {
    introMs: 300,
    loopMs: 4669,
    exits: [
      { startMs: 0, endMs: 609, outro: 0, outroMs: 300 },
      { startMs: 609, endMs: 1189, outro: 1, outroMs: 300 },
      { startMs: 1189, endMs: 1769, outro: 0, outroMs: 300 },
      { startMs: 1769, endMs: 2349, outro: 1, outroMs: 300 },
      { startMs: 2349, endMs: 2929, outro: 0, outroMs: 300 },
      { startMs: 3045, endMs: 3509, outro: 1, outroMs: 300 },
      { startMs: 3509, endMs: 4089, outro: 0, outroMs: 300 },
      { startMs: 4089, endMs: 4669, outro: 1, outroMs: 300 },
    ],
  },
  thinking: {
    introMs: 210,
    loopMs: 841,
    exits: [
      { startMs: 0, endMs: 29, outro: 0, outroMs: 210 },
      { startMs: 522, endMs: 551, outro: 1, outroMs: 210 },
    ],
  },
  type: {
    introMs: 270,
    loopMs: 8700,
    exits: [
      { startMs: 0, endMs: 145, outro: 0, outroMs: 270 },
      { startMs: 145, endMs: 174, outro: 1, outroMs: 270 },
      { startMs: 290, endMs: 319, outro: 1, outroMs: 270 },
      { startMs: 435, endMs: 464, outro: 1, outroMs: 270 },
      { startMs: 580, endMs: 609, outro: 1, outroMs: 270 },
      { startMs: 725, endMs: 754, outro: 2, outroMs: 270 },
      { startMs: 870, endMs: 899, outro: 2, outroMs: 270 },
      { startMs: 1015, endMs: 1044, outro: 2, outroMs: 270 },
      { startMs: 1160, endMs: 1189, outro: 2, outroMs: 270 },
      { startMs: 1305, endMs: 1334, outro: 2, outroMs: 270 },
      { startMs: 1450, endMs: 1479, outro: 2, outroMs: 270 },
      { startMs: 1595, endMs: 1624, outro: 2, outroMs: 270 },
      { startMs: 1740, endMs: 1769, outro: 1, outroMs: 270 },
      { startMs: 1885, endMs: 1914, outro: 1, outroMs: 270 },
      { startMs: 2030, endMs: 2059, outro: 1, outroMs: 270 },
      { startMs: 2175, endMs: 2204, outro: 1, outroMs: 270 },
      { startMs: 2320, endMs: 2349, outro: 1, outroMs: 270 },
      { startMs: 2465, endMs: 2494, outro: 1, outroMs: 270 },
      { startMs: 2610, endMs: 2639, outro: 1, outroMs: 270 },
      { startMs: 2755, endMs: 2784, outro: 1, outroMs: 270 },
      { startMs: 2900, endMs: 2929, outro: 1, outroMs: 270 },
      { startMs: 3045, endMs: 3074, outro: 1, outroMs: 270 },
      { startMs: 3190, endMs: 3219, outro: 1, outroMs: 270 },
      { startMs: 3335, endMs: 3364, outro: 1, outroMs: 270 },
      { startMs: 3480, endMs: 3509, outro: 0, outroMs: 270 },
      { startMs: 3596, endMs: 3915, outro: 0, outroMs: 270 },
      { startMs: 3915, endMs: 3944, outro: 1, outroMs: 270 },
      { startMs: 4060, endMs: 4089, outro: 1, outroMs: 270 },
      { startMs: 4205, endMs: 4234, outro: 1, outroMs: 270 },
      { startMs: 4350, endMs: 4379, outro: 1, outroMs: 270 },
      { startMs: 4495, endMs: 4524, outro: 1, outroMs: 270 },
      { startMs: 4640, endMs: 4669, outro: 1, outroMs: 270 },
      { startMs: 4785, endMs: 4814, outro: 1, outroMs: 270 },
      { startMs: 4930, endMs: 4959, outro: 1, outroMs: 270 },
      { startMs: 5075, endMs: 5104, outro: 1, outroMs: 270 },
      { startMs: 5220, endMs: 5249, outro: 1, outroMs: 270 },
      { startMs: 5365, endMs: 5394, outro: 1, outroMs: 270 },
      { startMs: 5510, endMs: 5539, outro: 1, outroMs: 270 },
      { startMs: 5655, endMs: 5684, outro: 1, outroMs: 270 },
      { startMs: 5800, endMs: 5829, outro: 1, outroMs: 270 },
      { startMs: 5945, endMs: 5974, outro: 1, outroMs: 270 },
      { startMs: 6090, endMs: 6148, outro: 0, outroMs: 270 },
      { startMs: 6235, endMs: 6293, outro: 0, outroMs: 270 },
      { startMs: 6380, endMs: 6409, outro: 1, outroMs: 270 },
      { startMs: 6525, endMs: 6554, outro: 1, outroMs: 270 },
      { startMs: 6670, endMs: 6699, outro: 1, outroMs: 270 },
      { startMs: 6815, endMs: 6844, outro: 1, outroMs: 270 },
      { startMs: 6960, endMs: 6989, outro: 1, outroMs: 270 },
      { startMs: 7105, endMs: 7134, outro: 1, outroMs: 270 },
      { startMs: 7250, endMs: 7279, outro: 1, outroMs: 270 },
      { startMs: 7540, endMs: 7569, outro: 1, outroMs: 270 },
      { startMs: 7685, endMs: 7714, outro: 1, outroMs: 270 },
      { startMs: 7830, endMs: 7859, outro: 1, outroMs: 270 },
      { startMs: 7975, endMs: 8004, outro: 1, outroMs: 270 },
      { startMs: 8120, endMs: 8149, outro: 1, outroMs: 270 },
      { startMs: 8265, endMs: 8700, outro: 0, outroMs: 270 },
    ],
  },
} as const;

export type AnvilTransitionVariant = keyof typeof ANVIL_TRANSITION_MANIFEST;

// Play-once clips layered behind a loop, on its 80px canvas, at random gaps
// while it rests, e.g. the Z's drifting off sleeping Codey (useAnvilOverlay).
// `clipMs` includes the clip's trailing empty frame.
export const ANVIL_OVERLAYS = {
  sleeping: { clip: "sleeping-z", clipMs: 1680 },
} as const;

// `useCoffeeSip` shows the sip clip for this long before swapping back to the
// held mug, so the number has to track the asset it describes.
export const ANVIL_COFFEE_TIMINGS = {
  sipMs: 2190,
} as const;

// MitosisCodey swaps the play-once mount clip for the idle loop after this
// long, so the number has to track the asset it describes.
export const MITOSIS_TIMINGS = {
  introMs: 2970,
} as const;

// Frames in each `anvil-materialize-<style>-<theme>.png` strip, laid left to
// right from empty to the neutral pose, 30ms each.
export const ANVIL_MATERIALIZE_FRAMES = {
  random: 13,
  outline: 15,
  scanline: 13,
} as const;

export type AnvilMaterializeStyle = keyof typeof ANVIL_MATERIALIZE_FRAMES;
